import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
export var chosenReasons = function chosenReasons(questionsById) {
  return Object.entries(questionsById).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      _ = _ref2[0],
      value = _ref2[1];
    return value.checked === true;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      _ = _ref4[0],
      value = _ref4[1];
    return value.label;
  }).join(" & ");
};